module.exports = __webpack_public_path__ + "static/media/img_prn48.fe0b30af.png";